import React from 'react';
import { FilterBadgeHookParams, MemberBadgeHookResult } from '../types';

interface Member {
  id: string;
  name?: string;
  email?: string;
  profilePicture?: string;
}

interface UseMemberBadges extends FilterBadgeHookParams {
  memberIds?: string[];
  members?: Member[];
}

export const useMemberBadges = ({ memberIds = [], members = [] }: UseMemberBadges): MemberBadgeHookResult => {
  const memberBadges = React.useMemo(
    () => members?.filter((member) => memberIds.includes(member.id)),
    [members, memberIds],
  );

  return {
    memberBadgesProps: {
      data: memberBadges,
    },
  };
};
